import axios from "axios";
import { headers } from "../exports/exports";
import { failed } from "../hooks/useToast";

export const fetchCompanyDetails = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-company-details?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error) {
    console.error("Server Error", error);
    failed();
  }
};
